// extracted by mini-css-extract-plugin
export default {"markdown":"Markdown_markdown__HH-UC","arabicMarkdown":"Markdown_arabicMarkdown__GnoRf"};